module.exports = __webpack_public_path__ + "img/Og-graph-p-1080.4323e17f.png";